import React from 'react';
import { useTranslation } from 'react-i18next';
import Money from '../../Common/Money/Money';
import Consumption from '../../Consumption/Consumption';
import Box from '../../Box/Box';
import { formatSeatDescription } from '../../../helpers/product';

const SummaryProducts = ({ reservationInfo }) => {
  const { t } = useTranslation();

  const renderProducts = () => {
    return (
      <>
        <div className='section-title mb-2'>{t('transactionDetail')}</div>
        <Box>
          {reservationInfo?.products.map((p, index) => {
            const hasExtraPaxs = p.extraPaxs > 0;
            const isLastProduct = index === reservationInfo?.products.length - 1;
            const isLastProductWithoutExtraPaxs = isLastProduct && !hasExtraPaxs;

            return (
              <div key={index}>
                <div className={!isLastProductWithoutExtraPaxs ? 'mb-3' : ''}>
                  <div className='text-tertiary fw-600'>{p.productName}</div>

                  {p.seatProps && (
                    <div className='text-tertiary font-tiny fw-400'>
                      {formatSeatDescription(p.seatProps, t)}
                    </div>
                  )}
                  {p.promotion && (
                    <div className='text-light-primary font-extra-small fw-400 mb-1'>
                      {t('promoDescription', { promotion: p.promotion.name })}
                    </div>
                  )}
                  {p.ageRange && (
                    <div className='text-secondary font-extra-small fw-400'>
                      {p.ageRange.nameString}
                    </div>
                  )}

                  {reservationInfo.reservationType === 'TRANSFER' && (
                    <div className='text-secondary font-extra-small fw-400'>
                      {t('upToGuests', { pax: p.maxPaxsPerItem })}
                    </div>
                  )}

                  <div className='text-secondary font-tiny fw-500'>
                    {!p.seatProps && reservationInfo.reservationType !== 'TRANSFER' && (
                      <>
                        <Money
                          value={p.amountPerUnitWithDiscount}
                          convert={false}
                          lowDecimals
                          decimal={false}
                        />{' '}
                        x {p.quantity} ={' '}
                      </>
                    )}
                    <Money
                      value={p.totalAmountWithoutExtraPaxsWithDiscount}
                      convert={false}
                      lowDecimals
                      decimal={false}
                    />
                  </div>
                </div>

                {hasExtraPaxs && (
                  <div className={isLastProduct ? 'mb-2' : 'mb-3'}>
                    <div className='text-tertiary fw-600'>{t('extraPassengers')}</div>

                    <div className='mb-1'>
                      <div className='text-secondary font-small fw-400'>{p.productName}</div>

                      <div className='text-secondary font-tiny fw-500'>
                        <Money
                          value={p.amountPerExtraPax}
                          convert={false}
                          lowDecimals
                          decimal={false}
                        />{' '}
                        x {p.extraPaxs} ={' '}
                        <Money
                          value={p.totalAmountExtraPaxs}
                          convert={false}
                          lowDecimals
                          decimal={false}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </Box>
      </>
    );
  };

  return (
    <>
      {renderProducts()}
      <Consumption amount={reservationInfo.consumptionAmount} />
    </>
  );
};

export default SummaryProducts;
